import { formatMoney } from 'src/utils/formatMoney';
import { useLocalization } from 'src/utils/useLocalization';
import './styles.scss';
interface IProps {
    accountType: string;
    privateFlag: boolean;
    quote: any;
}

interface IQouteItemProps {
    label: string;
    value: string | number;
    isPrivate: boolean;
}
const ZERO = 0;

const isGreaterThanZero = (value: number | string): boolean => {
    const num = Number(value);
    return !isNaN(num) && num > ZERO;
};

const isNotZero = (value: number | string): boolean => {
    const num = Number(value);
    return !isNaN(num) && num !== ZERO;
};

const QuoteItem = ({ label, value, isPrivate }: IQouteItemProps) => {
    const booleanPrivateString = isPrivate === true;
    const { payoffQuotesDetail } = useLocalization();

    function getprivateLabelOrValue(value: string | number) {
        return booleanPrivateString
            ? payoffQuotesDetail.PRIVATE
            : formatMoney(value);
    }
    const shouldRender = booleanPrivateString || isNotZero(value);
    return shouldRender ? (
        <div className='field-show'>
            <span className='label'>{label}</span>
            <span className='value weighted'>
                {getprivateLabelOrValue(value)}
            </span>
        </div>
    ) : null;
};

const QuoteDetails = ({ accountType, privateFlag, quote }: IProps) => {
    const data = quote;

    const { payoffQuotesQuoteDetails } = useLocalization();

    return (
        <section className='c-form-section payment-account-info'>
            <div className='c-form-section__content'>
                <div className='title'>
                    <h6>
                        <span className='c-section-heading__title-text u-mr-xxsmall section-title'>
                            {payoffQuotesQuoteDetails.TITLE}
                        </span>
                    </h6>
                </div>
                <div className='o-fieldset__row u-mt-large u-mb-large'>
                    <div className='o-layout'>
                        {accountType == 'OperatingLease' ? (
                            <>
                                <div className='o-layout__item  u-1/2  u-1/1@l'>
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_VALUE
                                        }
                                        value={data.residualValue}
                                        isPrivate={privateFlag}
                                    />
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_PAYOUT
                                        }
                                        value={data.residualTax}
                                        isPrivate={privateFlag}
                                    />
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_DUE
                                        }
                                        value={data.paymentDueNotPaid}
                                        isPrivate={privateFlag}
                                    />
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_TAXDUE
                                        }
                                        value={data.pastDueTaxAmt}
                                        isPrivate={privateFlag}
                                    />
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_PAYMENT
                                        }
                                        value={data.remainingFuturePaymentAmt}
                                        isPrivate={privateFlag}
                                    />
                                </div>
                                <div className='o-layout__item  u-1/2  u-1/1@l'>
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_TAXPAYMENT
                                        }
                                        value={data.futurePaymentTaxAmt}
                                        isPrivate={privateFlag}
                                    />
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_CHARGES
                                        }
                                        value={data.lateCharges}
                                        isPrivate={privateFlag}
                                    />
                                    {isGreaterThanZero(data.feeTotal) && (
                                        <>
                                            <QuoteItem
                                                label={
                                                    payoffQuotesQuoteDetails.LEASE_FEE_TITLE
                                                }
                                                value={data.feeTotal}
                                                isPrivate={privateFlag}
                                            />
                                            {data.fees?.length &&
                                            privateFlag === false
                                                ? data.fees.map((ele: any) => {
                                                      return (
                                                          <div
                                                              className='field-show fees-list'
                                                              key={ele.feeType}
                                                          >
                                                              <span className='label'>
                                                                  {
                                                                      (
                                                                          payoffQuotesQuoteDetails as any
                                                                      )[
                                                                          `LEASE_FEE_${ele.feeType}`
                                                                      ]
                                                                  }
                                                              </span>
                                                              <span className='value no-weighted'>
                                                                  {formatMoney(
                                                                      ele.amount,
                                                                  )}
                                                              </span>
                                                          </div>
                                                      );
                                                  })
                                                : null}
                                            <QuoteItem
                                                label={
                                                    payoffQuotesQuoteDetails.LEASE_FEE_TAX
                                                }
                                                value={data.taxOnFees}
                                                isPrivate={privateFlag}
                                            />
                                        </>
                                    )}
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.LEASE_FEE_CHARGE
                                        }
                                        value={data.leaseChargeRebate}
                                        isPrivate={privateFlag}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className='o-layout__item  u-1/2  u-1/1@l'>
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.RETAIL_BALANCE
                                        }
                                        value={data.residualValue}
                                        isPrivate={privateFlag}
                                    />
                                    <QuoteItem
                                        label={
                                            payoffQuotesQuoteDetails.RETAIL_INTEREST
                                        }
                                        value={data.interest}
                                        isPrivate={privateFlag}
                                    />
                                    {isGreaterThanZero(data.feeTotal) && (
                                        <QuoteItem
                                            label={
                                                payoffQuotesQuoteDetails.RETAIL_FEE
                                            }
                                            value={data.feeTotal}
                                            isPrivate={privateFlag}
                                        />
                                    )}
                                </div>
                                <div className='o-layout__item  u-1/2  u-1/1@l'>
                                    {isGreaterThanZero(data.feeTotal) &&
                                        data.fees?.length &&
                                        data.fees.map((ele: any) => {
                                            return (
                                                <QuoteItem
                                                    label={
                                                        (
                                                            payoffQuotesQuoteDetails as any
                                                        )[
                                                            `LEASE_FEE_${ele.feeType}`
                                                        ]
                                                    }
                                                    value={ele.amount}
                                                    isPrivate={privateFlag}
                                                    key={ele.feeType}
                                                />
                                            );
                                        })}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuoteDetails;
